<div class="step-action">
	<span class="step-back" (click)="goBackToHome()">
		<app-icon class="icon" iconName="arrow-back" />
		<span class="title">Back</span>
	</span>
	<span class="step-close" (click)="goBackToHome()"><app-icon class="icon" iconName="close" /></span>
</div>
<ul class="step-menu">
	<ng-container *ngFor="let step of routeItems; let i = index">
		<!-- TO DO - DISABLED STEP CHANGE - VALIDAR TODOS LOS FORMULARIOS ANTES DE ACTIVAR ESTA FUNCIONALIDAD -->
		<!-- (click)="onStepChange(i)" -->
		<li
			class="step-menu__item"
			[class.is-active]="i === activeStep"
			[class.is-completed]="i < activeStep"
		>
			<span class="step-menu__circle">{{ i + 1 }}</span>
			<span class="step-menu__label">{{ step.name }}</span>
		</li>
	</ng-container>
</ul>

<ng-container *ngIf="!bodyTarget">
	<div class="grid p-stepper-body">
		<div class="lg:col-12 md:col-12 sm:col-12 col-12">
			<div *ngFor="let item of routeItems; let i = index" [hidden]="activeStep !== i">
				<ng-container
					appComponentHost
					[stepId]="i"
					[component]="item.component"
					[componentHidden]="item.componentHidden"
					(instanceCreated)="onComponentInstanceCreated($event)" />
			</div>
		</div>
	</div>
</ng-container>
